import { PipeTransform, Pipe } from '@angular/core';
import { SiteSortField } from '../../enums';

@Pipe({
  name: 'siteSortField',
  standalone: false
})
export class SiteSortFieldPipe implements PipeTransform {
  public transform(value: SiteSortField): string {
    return getSiteSortField(value);
  }
}

export function getSiteSortField(value: any): string {
  switch (value) {
    case SiteSortField.Tier:
      return 'Tier';
    case SiteSortField.Title:
      return 'Title';
    case SiteSortField.Created:
      return 'Date Created';
    case SiteSortField.LastLogin:
      return 'Last Login';
    default:
      throw new Error(`Unsupported value for ProgramRole: ${value}.`);
  }
}

export function getSiteSortFieldList(): any[] {
  const enumArr = [];
  for (const enumMember in SiteSortField) {
    if (isNaN(+enumMember)) {
      enumArr.push({
        SortField: enumMember,
        Name: getSiteSortField(SiteSortField[enumMember])
      });
    }
  }
  return enumArr;
}
